import { Injectable } from "@angular/core";
import { environment } from "@edp-environments/environment";
import { IDevice, IDeviceOptOut } from "@edp-models/device.model";
import { ApiService } from "@edp-services/api.service";
import * as firebase from "firebase";
import { v4 as uuid } from "uuid";
import { DeviceDetectorService } from "ngx-device-detector";

@Injectable({
    providedIn: "root",
})
export class NotificationsService {
    private firebaseMessaging: firebase.messaging.Messaging;

    constructor(private apiService: ApiService, private readonly deviceDetector: DeviceDetectorService) {
        const app = firebase.initializeApp(environment.pushConfig, "secondary");

        if (firebase.messaging.isSupported() && this.deviceDetector.getDeviceInfo().os.toLowerCase() !== "ios") {
            this.firebaseMessaging = app.messaging();
        }
    }

    public sendOptOut(args: IDeviceOptOut) {
        return this.apiService.callServicePost(`device.pushState`, args);
    }

    public getOptOut(args: IDeviceOptOut) {
        return this.apiService.callServicePostToCollection(`device.getPushState`, args);
    }

    public registerDevice(args: IDevice) {
        return this.apiService.callServicePost(`device.register`, args);
    }

    public getPushConfigs() {
        return this.apiService.callServicePostToCollection(`userNotifications.getConfigNotification`, {});
    }

    public updatePushConfigs(args) {
        return this.apiService.callServicePostToCollection(`userNotifications.putConfigNotification`, args);
    }

    public requestPermission(): Promise<string | Error> {
        return new Promise(async (resolve, reject) => {
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
                const token = await this.firebaseMessaging.getToken();
                resolve(token);
                return;
            }
            reject(new Error("Permission denied"));
        });
    }

    public receiveMessage(): void {
        this.firebaseMessaging.onMessage(payload => console.log(payload.notification));
    }

    public getNewDeviceId() {
        const deviceId = uuid();
        localStorage.setItem("edp-push-browser", deviceId);
        return deviceId;
    }
}
